export const profile = {
  bg: 'https://college-official.oss-cn-hangzhou.aliyuncs.com/materials/project/talents/talent-banner.png',
  bgMD: 'https://college-official.oss-cn-hangzhou.aliyuncs.com/materials/project/talents/talent-banner-MD.png',
  label: '数字人才',
  subLabel: 'Digital Talent',
  content:
    '学会致力于推动数字人才培育，已推出一系列数字经济领域公益课程、市场化课程，包含数字经济科普、智能制造、企业数字化转型、数据要素、数据资产等多类课题。',
};
